import React from 'react';
import { IDesignerProfile, IDesignerSubStyle } from '@components/pages/DesignerProfile/graphql/designer-profile-query.graphql';
import AvatarImage from '@components/shared/AvatarImage/AvatarImage';
import { useTheme } from '@components/theme';
import classNames from 'classnames';
import DesignerGroupBadge from '@components/shared/Designers/components/DesignerGroupBadge/DesignerGroupBadge';
import designerGroups from '@constants/designerGroups';
import DesignerAvailableText from '@components/shared/DesignerAvailableText/DesignerAvailableText';
import Calendar from './calendar.svg';

import styles from './Profile.module.scss';

interface IProfileProps {
  designer: IDesignerProfile;
}

const Profile = ({ designer }: IProfileProps) => {
  const {
    photo, firstName, displayName, favoriteSubStyles, location, seoTitle
  } = designer;
  const theme = useTheme();

  return (
    <div className={ styles.Root }>
      <div className={ styles.Image }>
        <AvatarImage
          alt={`${displayName}`}
          imageUrl={photo}
          width={106}
          height={106}
        />
      </div>

      <h1
        data-test="interior-designers-designer"
        className={ theme.styles.Title1 }
        style={{ marginBottom: '0' }}
      >
        { firstName }
        {location && (
          <span
            className={styles.Location}
          >
            {location}
          </span>
        )}
      </h1>

      <DesignerGroupBadge
        designer={designer}
        forGroup={designerGroups.inPerson}
        classname={styles.BadgeWrapper}
      />

      <h2 className={classNames(
        theme.styles.Caption,
        styles.SubStyles
      )}
      >
        {seoTitle} Specializing in {joinSubStyles(favoriteSubStyles)} Design
      </h2>

      { !designer.isInPerson && (
        <div className={classNames(
          theme.styles.Body,
          styles.Availability
        )}
        >
          <Calendar />
          <DesignerAvailableText designer={designer} />
        </div>
      )}

    </div>
  );
};

function joinSubStyles(
  favoriteSubStyles: IDesignerSubStyle[] | undefined
) {
  return favoriteSubStyles?.map((fsb) => fsb.name)
    .join(' | ');
}

export default Profile;
